import { render } from "./Cleanup.vue?vue&type=template&id=2214c996&ts=true"
import script from "./Cleanup.vue?vue&type=script&lang=ts"
export * from "./Cleanup.vue?vue&type=script&lang=ts"

import "./Cleanup.vue?vue&type=style&index=0&id=2214c996&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__